<script setup>
const props = defineProps(['url'])
import {useLanguageStore} from "@/pinia";
const languageStore = useLanguageStore();

</script>

<template>
  <router-link :to="url" class="moreButton">
    <v-btn
        prepend-icon="mdi-arrow-right"
        variant="text"
        color="white"
    >
      {{languageStore.get('more')}}
    </v-btn>
  </router-link>
</template>

<style scoped>
.moreButton{
  color: #ffffff;
  min-width: 100px;
  background-color: #052C65;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  white-space: nowrap;
}

</style>